export default __webpack_public_path__ + "static/media/Vikendica 1.529c827b.jpeg";